// import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
// import URLstateContext from "../../provider/CommonContext";
// import Slider from "react-slick";
// import {
//   GetPostMethodData,
//   DecryptAESdata,
// } from "../../provider/ServiceProvider";
// import { Col, Container, Row } from "react-bootstrap";
// import hamburger from "../../images/hamburger.webp";
// import logo from "../../images/jm-logo.webp";
// import "./Header.css";
// import "./HamburgerMenu.css";
// import HamburgerMenu from "./HamburgerMenu";
// import { useLocation, useNavigate } from "react-router-dom";
// import coporate from "../../images/Mask_group_corporate.webp";
// import AMC from "../../images/Mask_gropuamc.png";
// import Sponsor from "../../images/Mask group-sponosor.png";
// import "./SearchPopup.css";
// import Close from "../../images/popup_close-btn.png";
// import popup_about1 from "../../images/popup_about-1.png";
// import popup_about2 from "../../images/popup_about-2.png";
// import popup_about3 from "../../images/popup_about-3.png";
// import popup_about5 from "../../images/popup_about-5.png";
// import popup_social1 from "../../images/popup_social-1.png";
// import popup_social2 from "../../images/popup_social-2.png";
// import popup_social3 from "../../images/popup_social-3.png";
// // import InvesterDistributerLogin from '../Login/InvesterDistributerLogin/InvesterDistributerLogin'
// import imglogout from "../../images/logout.png";
// import invester from "../../images/Investor.png";
// import partner from "../../images/partner.png";
// function Header() {
//   const [show, setShow] = React.useState(false);
//   const [showPop, setShowPop] = useState(false);
//   const { showPop, setShow
//     BaseURL,
//     fontSize,
//     changeFontSize,
//     resetFontSize,
//     changeFontSizeMinus,
//   } = useContext(URLstateContext);
//   const [SearchText, setSearchText] = useState("");
//   const [dataSearch, setDataSearch] = useState([]);
//   const [dataCompt, setDataCompt] = useState([]);
//   const [successmessage, setsuccessmessage] = useState(
//     localStorage.getItem("Valid")
//   );
//   const [username, setUsername] = useState(localStorage.getItem("UserName"));
//   const [showLoginPopup, setShowLoginPopup] = useState(false);
//   const [logoutpopup, setLogOutPopup] = useState(false);
//   const navigate = useNavigate();
//   // console.log(username)
//   const settings = {
//     dots: false,
//     infinite: false,
//     speed: 500,
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     arrows: true,
//     responsive: [
//       {
//         breakpoint: 575,
//         settings: {
//           slidesToShow: 5,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 4,
//         },
//       },
//       {
//         breakpoint: 360,
//         settings: {
//           slidesToShow: 4,
//         },
//       },
//     ],
//   };

//   useEffect(() => {
//     GetPostMethodData(BaseURL + "GetCompactSearchFund", {}).then((data) => {
//       if (data.data != null && data.data.length > 0) {
//         setDataCompt(DecryptAESdata(data.data));
//       }
//     });
//     GetPostMethodData(BaseURL + "GetFundSearch", {
//       IVsearch: SearchText,
//     }).then((data) => {
//       if (data.data != null && data.data.length > 0) {
//         setDataSearch(DecryptAESdata(data.data));
//         // console.log(DecryptAESdata(data.data))
//       } else {
//         setDataSearch([]);
//       }
//     });
//   }, [BaseURL, SearchText]);

//   function handleInputChange(event) {
//     document.getElementById("popup-box1").style.display = "block";
//     setShowPop(true);
//     let FundData = event.target.value;
//     if (FundData.length >= 3) {
//       setSearchText(FundData);
//     } else {
//       setSearchText("0");
//       setDataSearch([]);
//       setShowPop(false);
//     }
//   }

//   const clickHanlder = () => {
//     var element = document.getElementById("myDIV");
//     element.classList.add("side");
//   };
//   useEffect(() => {
//     window.addEventListener("scroll", isSticky);
//     return () => {
//       window.removeEventListener("scroll", isSticky);
//     };
//   });
//   const isSticky = (e) => {
//     const header = document.querySelector(".header-sc");
//     const scrollTop = window.scrollY;
//     scrollTop >= 0
//       ? header.classList.add("is-sticky")
//       : header.classList.remove("is-sticky");
//   };

//   const location = useLocation();
//   const { pathname } = location;
//   const splitLocation = pathname.split("/");

//   const myFunction = () => {
//     document.getElementById("myDropdown").classList.toggle("show");
//     // navigate('/Login')
//     // setShowLoginPopup((showLoginPopup) => !showLoginPopup);
//   };
//   const handleClosePopuplogin = () => {
//     // setShowLoginPopup(false);
//   };
//   const popuplogout = () => {
//     setLogOutPopup((logoutpopup) => !logoutpopup);
//   };
//   const closeNav = () => {
//     setLogOutPopup(false);
//   };
//   const logout = () => {
//     const confirmLogout = window.confirm("Are you sure you want to logout?");
//     if (confirmLogout) {
//       localStorage.removeItem("Valid");
//       setsuccessmessage(null);
//       setLogOutPopup(false);
//       navigate("/");
//     } else {
//       setLogOutPopup(false);
//     }
//   };
//   window.onclick = function (event) {
//     if (!event.target.matches(".dropbtn")) {
//       var dropdowns = document.getElementsByClassName("dropdown-content");
//       var i;
//       for (i = 0; i < dropdowns.length; i++) {
//         var openDropdown = dropdowns[i];
//         if (openDropdown.classList.contains("show")) {
//           openDropdown.classList.remove("show");
//         }
//       }
//     }
//   };
//   // window.addEventListener('mouseup', function (event) {
//   //     var pol = document.getElementById('aboutus');
//   //     if (event.target != pol && event.target.parentNode != pol) {
//   //         document.getElementById('aboutus').style.display = 'none';
//   //     }
//   // });

//   window.addEventListener("mouseup", function (event) {
//     var fundPol = document.getElementById("popup-box1");
//     if (event.target != fundPol && event.target.parentNode != fundPol) {
//       document.getElementById("popup-box1").style.display = "none";
//       let searchInput = document.getElementById("search_fund");
//       searchInput.value = "";
//     }
//   });

//   const OpenSearch = () => {
//     document.getElementById("popup-box1").style.display = "block";
//     setShowPop(false);
//   };
//   const clickGetSchemes = (event) => {
//     const schemeId = event.currentTarget.dataset.id;
//     const schemeType = event.currentTarget.dataset.type;
//     const schemeName = event.currentTarget.dataset.name;
//     const schemeDesc = event.currentTarget.dataset.disc;
//     window.open(
//       "/products/" +
//         schemeType.replace(/ /g, "-").replace("&", "and").replace("+", "") +
//         "/" +
//         schemeName.replace(/ /g, "-").replace("&", "and").replace("+", "") +
//         "/" +
//         schemeId +
//         "/" +
//         schemeDesc.replace(/ /g, "-").replace("&", "and"),
//       "_self"
//     );
//     let searchInput = document.getElementById("search_fund");
//     searchInput.value = "";
//   };
//   const closepopup = () => {
//     document.getElementById("popup-box1").style.display = "none";
//     let searchInput = document.getElementById("search_fund");
//     searchInput.value = "";
//   };

//   const userData = { successmessage };
//   // const expiryTime = 1 * 60 * 60 * 1000;
//   const expiryTime = 1000 * 60 * 15;
//   const currentTime = new Date().getTime();

//   useEffect(() => {
//     setsuccessmessage(localStorage.getItem("Valid"));
//     setUsername(localStorage.getItem("UserName"));
//   }, []);

//   return (
//     <>
//       {/* <HamburgerMenu /> */}
//       <section className="header-sc">
//         <Container>
//           <Row>
//             {/* <p className="exting-web">
//               Please{" "}
//               <a href="/Confirmation" target="_blank">
//                 click here
//               </a>{" "}
//               in case you want to access our previous website.
//             </p> */}
//             {/* <p className="exting-web">Your browsing experience matters to us. If you're facing difficulties with files or links, <a href="https://www.prev.jmfinancialmf.com/" target="blank">click here</a> to visit our old website</p> */}
//             <Col sm={12}>
//               <HamburgerMenu />
//               <div className="logo-img">
//                 <a href="/">
//                   <img src={logo} alt="logo-img" className="img-fluid" />
//                 </a>
//               </div>

//               <div className="menu-pnl">
//                 <div className="menu-desk">
//                   <ul id="HeaderDiv">
//                     <li className={splitLocation[1] === "" ? "active" : ""}>
//                       <a href="" className="HeadA">
//                         Investor
//                       </a>
//                     </li>
//                     <li
//                       className={
//                         splitLocation[1] === "PartnersCorner" ? "active" : ""
//                       }
//                     >
//                       <a href="/PartnersCorner" className="HeadA">
//                         Partner
//                       </a>
//                     </li>
//                     <li
//                       className={
//                         splitLocation[1] === "products" ? "active" : ""
//                       }
//                     >
//                       <a href="/products" className="HeadA">
//                         Products
//                       </a>
//                     </li>
//                     <li
//                       className={
//                         splitLocation[1] === "Insights" ? "active" : ""
//                       }
//                     >
//                       <a href="/Insights/Video-Gallery" className="HeadA">
//                         Insights
//                       </a>

//                       {/* <a href="/Insights" className="HeadA">
//                         Insights
//                       </a> */}
//                     </li>
//                     <li
//                       className={
//                         splitLocation[1] === "downloads" ? "active" : ""
//                       }
//                     >
//                       <a
//                         className="cursorpointer HeadA"
//                         href="/downloads/Factsheet"
//                       >
//                         Downloads
//                       </a>
//                     </li>
//                     <li
//                       className={
//                         splitLocation[1] === "Reach-Us" ? "active" : ""
//                       }
//                     >
//                       <a href="/Reach-Us" className="HeadA">
//                         Reach Us
//                       </a>
//                     </li>
//                     {/* <li className={splitLocation[1] === "WhoWeAre" ? "active" : ""} onClick={() => setShow(!show)}><a className='HeadA'>Who We Are</a></li> */}
//                     <li
//                       className={splitLocation[1] === "AboutUs" ? "active" : ""}
//                     >
//                       <a href="/AboutUs" className="HeadA">
//                         About Us
//                       </a>
//                     </li>
//                     <li
//                       className={
//                         splitLocation[1] === "KycUpdate" ? "active" : ""
//                       }
//                     >
//                       <a href="/KycUpdate" className="HeadA blink_me">
//                         KYC Status
//                       </a>
//                     </li>
//                   </ul>
//                 </div>
//                 <div className="menu-mobile">
//                   <Slider {...settings}>
//                     <div>
//                       <p className={splitLocation[1] === "" ? "active" : ""}>
//                         <a href="" className="HeadA">
//                           Investor
//                         </a>
//                       </p>
//                     </div>
//                     <div>
//                       <p
//                         className={
//                           splitLocation[1] === "PartnersCorner" ? "active" : ""
//                         }
//                       >
//                         <a href="/PartnersCorner" className="HeadA">
//                           Partner
//                         </a>
//                       </p>
//                     </div>
//                     <div>
//                       <p
//                         className={
//                           splitLocation[1] === "products" ? "active" : ""
//                         }
//                       >
//                         <a href="/products" className="HeadA">
//                           Products
//                         </a>
//                       </p>
//                     </div>
//                     <div>
//                       <p
//                         className={
//                           splitLocation[1] === "Insights" ? "active" : ""
//                         }
//                       >
//                         <a href="/Insights/Video-Gallery" className="HeadA">
//                           Insights
//                         </a>
//                       </p>
//                     </div>
//                     <div>
//                       <p
//                         className={
//                           splitLocation[1] === "downloads" ? "active" : ""
//                         }
//                       >
//                         <a className="cursorpointer HeadA" href="/downloads/Factsheet">
//                           Downloads
//                         </a>
//                       </p>
//                     </div>
//                     <div>
//                       <p
//                         className={
//                           splitLocation[1] === "Reach-Us" ? "active" : ""
//                         }
//                       >
//                         <a href="/Reach-Us" className="HeadA">
//                           Reach Us
//                         </a>
//                       </p>
//                     </div>
//                     <div>
//                       <p
//                         className={
//                           splitLocation[1] === "AboutUs" ? "active" : ""
//                         }
//                       >
//                         <a href="/AboutUs" className="HeadA">
//                           About Us
//                         </a>
//                       </p>
//                     </div>
//                     <div>
//                       <p
//                         className={
//                           splitLocation[1] === "KycUpdate" ? "active" : ""
//                         }
//                       >
//                         <a href="/KycUpdate" className="HeadA blink_me">
//                           KYC Status
//                         </a>
//                       </p>
//                     </div>
//                   </Slider>
//                 </div>
//                 <div className="App-font-incr" style={{ margin: "2" }}>
//                   <button
//                     className="btna"
//                     type="button"
//                     name="btn1"
//                     onClick={() => changeFontSizeMinus(1)}
//                   >
//                     -A
//                   </button>
//                   <button
//                     className="btna"
//                     type="button"
//                     name="btn3"
//                     onClick={resetFontSize}
//                   >
//                     A
//                   </button>
//                   <button
//                     className="btna"
//                     type="button"
//                     name="btn2"
//                     onClick={() => changeFontSize(1)}
//                   >
//                     A+
//                   </button>
//                 </div>

//                 {/* <div className="arrows">
//                                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
//                                 </div> */}
//               </div>

//               <div className="login-ham-btn dropdown">
//                 <ul>
//                   <button onClick={myFunction} className="login-btn dropbtn">
//                     {" "}
//                     Login
//                   </button>
//                   {/* {successmessage != 'Y' ?
//                                         <button onClick={myFunction} className='login-btn dropbtn'>

//                                             Login</button>
//                                         : <button onClick={popuplogout} className='login-btn dropbtn'>

//                                             {username.charAt(0)}
//                                         </button>
//                                     } */}
//                   {/* {successmessage == 'Y' && ( } }
//                                         {/* <button onClick={logout} className='login-btn dropbtn'>

//                                            {username.charAt(0)}
//                                            </button> */}
//                   {/* )} */}
//                   <div
//                     id="myDropdown"
//                     className="dropdown-content login-popup-link"
//                   >
//                     <ul className="link-div-popup">
//                       <li>
//                         <img src={invester} alt="invester" />
//                         <a
//                           href="https://investor.jmfinancialmf.com/jmfinvestor/"
//                           target="_blank"
//                         >
//                           Investor
//                         </a>
//                       </li>
//                       <li>
//                         <img src={partner} alt="partner" />
//                         <a
//                           href="https://dit.jmfinancialmf.com/portal/login"
//                           target="_blank"
//                         >
//                           Partner
//                         </a>
//                       </li>
//                     </ul>
//                   </div>

//                   <li onClick={clickHanlder}>
//                     <img
//                       src={hamburger}
//                       alt="hamburger"
//                       className="img-fluid"
//                     ></img>
//                   </li>
//                 </ul>
//               </div>
//               {show && (
//                 <div id="aboutus" className="who-we-are-popup">
//                   <div className="text-div">
//                     <h2>About Us</h2>
//                     <p>
//                       JM Financial Will Be The Most Trusted Partners For Every
//                       Stakholder In Financial World.
//                     </p>
//                   </div>
//                   <div className="link-div">
//                     <ul>
//                       <li>
//                         <a href="//OurCororpate">
//                           <img src={coporate} alt="coporate" />
//                           Teams
//                         </a>
//                       </li>
//                       <li>
//                         <a href="/AboutUs/TheAMC">
//                           <img src={AMC} alt="AMC" />
//                           AMC Board
//                         </a>
//                       </li>
//                       <li>
//                         <a href="/AboutUs/Sponsor">
//                           <img src={Sponsor} alt="Sponsor" />
//                           Sponsor
//                         </a>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               )}
//             </Col>
//             <div className="search-bar-wrapper" id="search-bar-wrapper">
//               <div className="container">
//                 <div className="search-bar-container">
//                   <input
//                     type="text"
//                     name=""
//                     id="search_fund"
//                     placeholder="Search for products and services..."
//                     onClick={OpenSearch}
//                     onChange={handleInputChange}
//                   />
//                   <div className="icon-container">
//                     <i className="fa fa-search" aria-hidden="true"></i>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div id="popup-box1" className="popup-position">
//               <div className="search-popup-container">
//                 {!showPop && (
//                   <div className="left">
//                     <div className="invest">
//                       <p className="head">Popular Search</p>
//                       <div className="invest-fund">
//                         {dataCompt &&
//                           dataCompt.map(({ SectionName, LinkPath }) => (
//                             <>
//                               <div className="funds">
//                                 <a href={LinkPath != null ? LinkPath : ""}>
//                                   {SectionName}
//                                 </a>
//                               </div>
//                             </>
//                           ))}
//                       </div>
//                     </div>
//                     <div className="looking-section">
//                       <div className="invest">
//                         <p className="head">I want to Invest in</p>
//                         <div className="invest-fund">
//                           <div className="funds">
//                             <a
//                               href={
//                                 "products/Equity/JM-Flexicap-Fund/J358/Regular-Plan-Growth-Option"
//                               }
//                             >
//                               JM Flexi Cap Fund
//                             </a>
//                           </div>
//                           <div className="funds">
//                             {/* <a
//                               href={
//                                 "/products/Equity/JM-ELSS-Tax-Saver-Fund-(Formerly-known-as-JM-Tax-Gain-Fund)/J282/Regular-Plan-Growth-Option"
//                               }
//                             > */}
//                               <a
//                               href={
//                                 "/products/Equity/JM-ELSS-Tax-Saver-Fund/J282/Regular-Plan-Growth-Option"
//                               }
//                             >

//                               JM ELSS Tax Saver Fund
//                             </a>
//                           </div>
//                           <div className="funds">
//                             <a
//                               href={
//                                 "products/Equity/JM-Midcap-Fund/J644/Regular-Plan-Growth-Option"
//                               }
//                             >
//                               JM Midcap Fund
//                             </a>
//                           </div>
//                           <div className="funds">
//                             <a
//                               href={
//                                 "products/Equity/JM-Value-Fund/J246/Regular-Plan-Growth-Option"
//                               }
//                             >
//                               JM Value Fund
//                             </a>
//                           </div>
//                           <div className="funds">
//                             <a
//                               href={
//                                 "products/Fixed-Income/JM-Short-Duration-Fund/J638/Regular-Plan-Growth-Option"
//                               }
//                             >
//                               JM Short Duration Fund
//                             </a>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//                 {/* {showPop && (<div className="left fundNew">
//                                     <div className="popupFundSearch">
//                                         {(dataSearch.length > 0) ?
//                                             dataSearch && dataSearch.map(({ Title, SectionPath, Description }) => (
//                                                 <div className="popupFund">
//                                                     <h2>{Title}</h2>
//                                                     <div className="fundDiv">
//                                                         <p>{Description}</p>
//                                                         <a href={SectionPath}>Know More</a>
//                                                     </div>
//                                                     <hr></hr>
//                                                 </div>
//                                             )) : <h6 className="errorSearch">No Data Found !!!</h6>}
//                                     </div>
//                                 </div>)} */}
//                 {showPop && (
//                   <div className="left fundNew">
//                     <div className="popupFundSearch">
//                       {dataSearch && dataSearch.length > 0 ? (
//                         dataSearch.map(
//                           ({ Title, SectionPath, Description }) => (
//                             <div className="popupFund" key={SectionPath}>
//                               <h2>{Title}</h2>
//                               <div className="fundDiv">
//                                 <p>{Description}</p>
//                                 <a href={SectionPath}>Know More</a>
//                               </div>
//                               <hr />
//                             </div>
//                           )
//                         )
//                       ) : (
//                         <h6 className="errorSearch">No Data Found !!!</h6>
//                       )}
//                     </div>
//                   </div>
//                 )}
//                 <div className="right">
//                   <div className="head">
//                     <p>What are you looking for?</p>
//                   </div>
//                   <ul className="partners-container">
//                     <li>
//                       <span className="img-container">
//                         <img src={popup_about1} alt="FactSheets" />
//                       </span>
//                       <p>
//                         <a href="/downloads/Factsheet">Factsheet</a>
//                       </p>
//                     </li>
//                     <li>
//                       <span className="img-container">
//                         <img src={popup_about2} alt="NAVs-and-IDCW" />
//                       </span>
//                       <p>
//                         <a href="/NAVs-and-IDCW/">NAV’s & IDCW</a>
//                       </p>
//                     </li>
//                     <li>
//                       <span className="img-container">
//                         <img src={popup_about3} alt="products" />
//                       </span>
//                       <p>
//                         <a href="/products">Products</a>
//                       </p>
//                     </li>
//                     {/* <li>
//                                             <span className="img-container">
//                                                 <img src={popup_about4} alt="Plan-Wise-Investment" />
//                                             </span>
//                                             <p><a href='Calculator/Plan-Wise-Investment'>Calculator</a></p>
//                                         </li> */}
//                     <li>
//                       <span className="img-container">
//                         <img src={popup_about5} alt="PressRelease" />
//                       </span>
//                       <p>
//                         <a href="Communication-Hub/media-interaction">
//                           Communication Hub
//                         </a>
//                       </p>
//                     </li>
//                     <div className="portal-box">
//                       <p>
//                         <a
//                           href="https://investor.jmfinancialmf.com/jmfinvestor/"
//                           target="blank"
//                         >
//                           Investor Portal
//                         </a>
//                       </p>
//                       <p>
//                         <a
//                           href="https://dit.jmfinancialmf.com/portal/login"
//                           target="blank"
//                         >
//                           Partner Portal
//                         </a>
//                       </p>
//                     </div>
//                   </ul>
//                 </div>
//                 <div className="top-bar-btns">
//                   <ul className="social-icons">
//                     <li>
//                       <a
//                         target="_blank"
//                         href="https://www.youtube.com/@JMFinancialAMC/"
//                       >
//                         <img src={popup_social1} alt="popup_social1" />
//                       </a>
//                     </li>
//                     <li>
//                       <a
//                         target="_blank"
//                         href="https://www.linkedin.com/company/jm-financial-mutual-fund-ltd/mycompany/"
//                       >
//                         <img src={popup_social2} alt="popup_social2" />
//                       </a>
//                     </li>
//                     <li>
//                       <a
//                         target="_blank"
//                         href="https://www.instagram.com/jmfinancialmutualfund/"
//                       >
//                         <img src={popup_social3} alt="popup_social3" />
//                       </a>
//                     </li>
//                   </ul>
//                   <button className="close-btn">
//                     <img src={Close} alt="Close" onClick={closepopup} />
//                   </button>
//                 </div>
//               </div>
//             </div>
//             {logoutpopup ? (
//               <div className="user_profile">
//                 <div id="overlay" onClick={closeNav}>
//                   {" "}
//                 </div>
//                 <Container>
//                   <Row>
//                     <Col xs={12}>
//                       <div className="user_profile">
//                         <div className="userprofile_dropdown">
//                           <div className="userprofile_bio media">
//                             <div className="usernameimg_panel media">
//                               <span className="user_fname">
//                                 {username != null
//                                   ? username.substring(0, 1)
//                                   : ""}
//                               </span>
//                             </div>
//                             <div className="user_nameemail media-body">
//                               <span className="userbio_name">{username}</span>
//                             </div>
//                           </div>

//                           <div className="userprofile_biogrid">
//                             <ul className="userprofile_biolist">
//                               <li>
//                                 <span className="userprfl_bioicon">
//                                   <img
//                                     src={imglogout}
//                                     className="orderreport"
//                                   />
//                                 </span>
//                                 <span
//                                   className="userprfl_biotext"
//                                   onClick={logout}
//                                 >
//                                   Logout
//                                 </span>
//                               </li>
//                             </ul>
//                           </div>
//                         </div>
//                       </div>
//                     </Col>
//                   </Row>
//                 </Container>
//               </div>
//             ) : null}
//           </Row>
//         </Container>
//       </section>
//       {/* {showLoginPopup && <InvesterDistributerLogin handleClosePopuplogin={handleClosePopuplogin} />} */}
//       {/* <InvesterDistributerLogin showpopup={showLoginPopup} handleClosePopuplogin={handleClosePopuplogin} /> */}
//     </>
//   );
// }

// export default Header;

import React, { useState, useEffect, useContext, useMemo, useRef, useCallback } from "react";
import URLstateContext from "../../provider/CommonContext";
import Slider from "react-slick";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../provider/ServiceProvider";
import { Col, Container, Row } from "react-bootstrap";
import hamburger from "../../images/hamburger.webp";
// import logo from "../../images/new_header_logo_.svg";
// import logo from "../../images/JMF_Mutual Fund_ Main-fill-new.svg";
import logo from "../../images/jm_logo_dark.png";
// import logo from "../../images/jm_new_logo_dec.svg";
// import logo from "../../images/JMF_AssetManagement_Main_NEW_1 1.svg"
import "./Header.css";
import "./HamburgerMenu.css";
import HamburgerMenu from "./HamburgerMenu";
import { useLocation, useNavigate } from "react-router-dom";
import coporate from "../../images/Mask_group_corporate.webp";
import AMC from "../../images/Mask_gropuamc.png";
import Sponsor from "../../images/Mask group-sponosor.png";
import "./SearchPopup.css";
import Close from "../../images/popup_close-btn.png";
import popup_about1 from "../../images/popup_about-1.png";
import popup_about2 from "../../images/popup_about-2.png";
import popup_about3 from "../../images/popup_about-3.png";
import popup_about5 from "../../images/popup_about-5.png";
import popup_social1 from "../../images/popup_social-1.png";
import popup_social2 from "../../images/popup_social-2.png";
import popup_social3 from "../../images/popup_social-3.png";
// import InvesterDistributerLogin from '../Login/InvesterDistributerLogin/InvesterDistributerLogin'
import imglogout from "../../images/logout.png";
import invester from "../../images/Investor.png";
import partnerImage from "../../images/partner.png";
import { Dropdown, Space } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import FontSizeController from "../FontSizeComponents/FontSizeController";
// import { useSkip } from "../../context/SkipToMainContent";
import DarkModeTheme from "../DarkModeTheme/DarkModeTheme";
import useDropdownAccessibility from "../../hooks/useDropdownAccessibility";
function Header() {
  const [show, setShow] = React.useState(false);
  const [showPop, setShowPop] = useState(false);
  const {
    BaseURL,
    fontSize,
    changeFontSize,
    resetFontSize,
    changeFontSizeMinus,
  } = useContext(URLstateContext);
  const [SearchText, setSearchText] = useState("");
  const [dataSearch, setDataSearch] = useState([]);
  const [dataCompt, setDataCompt] = useState([]);
  const [successmessage, setsuccessmessage] = useState(
    localStorage.getItem("Valid"),
  );
  const [username, setUsername] = useState(localStorage.getItem("UserName"));
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [logoutpopup, setLogOutPopup] = useState(false);
  const navigate = useNavigate();

  const [openAbout, setOpenAbout] = useState(false);
const [openReachUs, setOpenReachUs] = useState(false);
const [openDownloads, setOpenDownloads] = useState(false);
const [openInsights, setOpenInsights] = useState(false);
const [openProducts, setOpenProducts] = useState(false);
const [openPartner, setOpenPartner] = useState(false);
const [openInvestor, setOpenInvestor] = useState(false);
const [openLogin, setOpenLogin] = useState(false);


const investor  = useDropdownAccessibility(openInvestor,  setOpenInvestor);
const partner   = useDropdownAccessibility(openPartner,   setOpenPartner);
const products  = useDropdownAccessibility(openProducts,  setOpenProducts);
const insights  = useDropdownAccessibility(openInsights,  setOpenInsights);
const downloads = useDropdownAccessibility(openDownloads, setOpenDownloads);
const reachUs   = useDropdownAccessibility(openReachUs,   setOpenReachUs);
const about     = useDropdownAccessibility(openAbout,     setOpenAbout);


const kycRef = useRef(null);

useEffect(() => {
  investor.setNext(partner.triggerRef);    // Investor  → Partner
  partner.setNext(products.triggerRef);   // Partner   → Products
  products.setNext(insights.triggerRef);  // Products  → Insights
  insights.setNext(downloads.triggerRef); // Insights  → Downloads
  downloads.setNext(reachUs.triggerRef);  // Downloads → Reach Us
  reachUs.setNext(about.triggerRef);      // Reach Us  → About Us
  about.setNext(kycRef);                  // About Us  → KYC Status
}, []);

// const { setSkipActive } = useSkip();
// const {skipActive} = useSkip();

const loginMenuItemsRef = useRef([]);

const toggleDropdown = () => {
  setOpenLogin(prev => !prev);
   document.getElementById("myDropdown").classList.toggle("show");
};

  const myFunction = () => {
    document.getElementById("myDropdown").classList.toggle("show");
    // navigate('/Login')
    // setShowLoginPopup((showLoginPopup) => !showLoginPopup);
  };

  // console.log(username)
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  };

  useEffect(() => {
    GetPostMethodData(BaseURL + "GetCompactSearchFund", {}).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataCompt(DecryptAESdata(data.data));
      }
    });
    GetPostMethodData(BaseURL + "GetFundSearch", {
      IVsearch: SearchText,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataSearch(DecryptAESdata(data.data));
        // console.log(DecryptAESdata(data.data))
      } else {
        setDataSearch([]);
      }
    });
  }, [BaseURL, SearchText]);

  function handleInputChange(event) {
    document.getElementById("popup-box1").style.display = "block";
    setShowPop(true);
    let FundData = event.target.value;
    if (FundData.length >= 3) {
      setSearchText(FundData);
    } else {
      setSearchText("0");
      setDataSearch([]);
      setShowPop(false);
    }
  }

  const clickHanlder = () => {
    var element = document.getElementById("myDIV");
    element.classList.add("side");
  };
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });
  const isSticky = (e) => {
    const header = document.querySelector(".header-sc");
    const scrollTop = window.scrollY;
    scrollTop >= 0
      ? header.classList.add("is-sticky")
      : header.classList.remove("is-sticky");
  };

  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const handleClosePopuplogin = () => {
    // setShowLoginPopup(false);
  };
  const popuplogout = () => {
    setLogOutPopup((logoutpopup) => !logoutpopup);
  };
  const closeNav = () => {
    setLogOutPopup(false);
  };
  const logout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");
    if (confirmLogout) {
      localStorage.removeItem("Valid");
      setsuccessmessage(null);
      setLogOutPopup(false);
      navigate("/");
    } else {
      setLogOutPopup(false);
    }
  };
  window.onclick = function (event) {
    if (!event.target.matches(".dropbtn")) {
      var dropdowns = document.getElementsByClassName("dropdown-content");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains("show")) {
          openDropdown.classList.remove("show");
        }
      }
    }
  };
  // window.addEventListener('mouseup', function (event) {
  //     var pol = document.getElementById('aboutus');
  //     if (event.target != pol && event.target.parentNode != pol) {
  //         document.getElementById('aboutus').style.display = 'none';
  //     }
  // });

 window.addEventListener("mouseup", function (event) {
  const fundPol = document.getElementById("popup-box1");

  if (!fundPol) return;

  if (event.target !== fundPol && !fundPol.contains(event.target)) {
    fundPol.style.display = "none";

    const searchInput = document.getElementById("search_fund");

    if (searchInput) {
      searchInput.value = "";
    }
  }
});

  const OpenSearch = () => {
    document.getElementById("popup-box1").style.display = "block";
    setShowPop(false);
  };
  const clickGetSchemes = (event) => {
    const schemeId = event.currentTarget.dataset.id;
    const schemeType = event.currentTarget.dataset.type;
    const schemeName = event.currentTarget.dataset.name;
    const schemeDesc = event.currentTarget.dataset.disc;
    window.open(
      "/products/" +
        schemeType.replace(/ /g, "-").replace("&", "and").replace("+", "") +
        "/" +
        schemeName.replace(/ /g, "-").replace("&", "and").replace("+", "") +
        "/" +
        schemeId +
        "/" +
        schemeDesc.replace(/ /g, "-").replace("&", "and"),
      "_self",
    );
    let searchInput = document.getElementById("search_fund");
    searchInput.value = "";
  };
  const closepopup = () => {
    document.getElementById("popup-box1").style.display = "none";
    let searchInput = document.getElementById("search_fund");
    searchInput.value = "";
  };

  const userData = { successmessage };
  // const expiryTime = 1 * 60 * 60 * 1000;
  const expiryTime = 1000 * 60 * 15;
  const currentTime = new Date().getTime();

  useEffect(() => {
    setsuccessmessage(localStorage.getItem("Valid"));
    setUsername(localStorage.getItem("UserName"));
  }, []);

  const productMenu = {
    items: [
      {
        key: "1",
        label: <a href="/products">All</a>,
      },
      {
        key: "2",
        label: <a href="/products/Equity">Equity</a>,
      },
      {
        key: "3",
        label: <a href="/products/debt">Fixed Income</a>,
      },
      {
        key: "4",
        label: <a href="/products/Hybrid">Hybrid</a>,
      },
      //  {
      //  key : "5",
      //  label : <a href="/products/aif">AIF Page</a>
      // },
    ],
  };

  // const investorMenu = {
  //   items: [
  //     {
  //       key: "1",
  //       label: <a href="/explore-funds">Explore our funds</a>,
  //     },
  //     {
  //       key: "2",
  //       label: <a href="/Insights/Video-Gallery">Video Gallery</a>,
  //     },
  //     {
  //       key: "3",
  //       label: <a href="/help">How Can we Help You</a>,
  //     },
  //     {
  //       key: "4",
  //       label: <a href="/Insights">Insights</a>,
  //     },
  //   ],
  // };

  const investorMenu = {
    'aria-label' : 'Investor Menu',
    items: [
      {
        key: "1",
        label: <a href="/#explore-funds">Explore our funds</a>,
      },
      {
        key: "2",
        label: <a href="/#video-gallery">Video Gallery</a>,
      },
      {
        key: "3",
        label: <a href="/#help-section">How Can we Help You</a>,
      },
      {
        key: "4",
        label: <a href="/#insights">Insights</a>,
      },
    ],
  };

  const partnerCornerMenu = {
    items: [
      {
        key: "1",
        label: (
          <a
            href="https://onboarding.jmfinancialmf.com/login"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Online Empanelment
          </a>
        ),
      },
      {
        key: "2",
        label: (
          <a href="/PartnersCorner/OfflineEmpanelment"> Offline Empanelment</a>
        ),
      },

      {
        key: "3",
        label: (
          <a
            href="https://dit.jmfinancialmf.com/portal/login"
            target="_blank"
            rel="noreferrer"
          >
            Transaction Platform
          </a>
        ),
      },
      {
        key: "4",
        label: (
          <a
            href="https://dit.jmfinancialmf.com/easylink"
            target="_blank"
            rel="noreferrer"
          >
            Easy Links
          </a>
        ),
      },
      {
        key: "5",
        label: (
          <a href="/PartnersCorner/ProcessAndService"> Process and Services</a>
        ),
      },
      {
        key: "6",
        label: (
          <a
            href="https://jmcobrand.anchoredgetechno.com/"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Co-Branded Collateral
          </a>
        ),
      },
    ],
  };

  //   const videoGalleryMenu = {
  //   items: [
  //     {
  //       key: "1-1",
  //       label: <a href="/market-outlook">Market Outlook</a>,
  //     },
  //     {
  //       key: "1-2",
  //       label: <a href="/bateezin-baazar">Bateezin Baazar</a>,
  //     },
  //     {
  //       key: "1-3",
  //       label: <a href="/other-videos">Other Videos</a>,
  //     },
  //   ],
  // };

  // Main Insights menu

  const insightsMenu = {
    items: [
      {
        key: "videoGallery",
        label: "Video Gallery",
        children: [
          {
            key: "marketOutlook",
            label: (
              <a href="/Insights/VideoGallery/MarketOutlook">Market Outlook</a>
            ),
          },
          // {
          //   key: "baateinBaazar",
          //   label: <a href="/Insights/VideoGallery/baateinbazaar-beyond">Baatein Baazar</a>,
          // },
          {
            key: "otherVideos",
            label: (
              <a href="/Insights/VideoGallery/otherVideos">NFO & OTHER VIDEOS</a>
            ),
          },
        ],
      },
      {
        key: "documentGallery",
        label: <a href="/Insights/Document-Gallery">Document Gallery</a>,
      },
      {
        key: "calendar",
        label: <a href="/Insights/Calendar-2026">Calendar 2026</a>,
      },
      {
        key: "outlook",
        label: <a href="/Insights/Outlook-2026">Outlook 2026</a>,
      },
      // {
      //   key: "sipCalculator",
      //   label: <a href="/sipcalculator">SIP Calculator</a>,
      // },
    ],
  };

 const downloadsMenu = {
  items: [
    // { key: "1", label: <a href="/downloads/NFO">NFO</a> },

    { key: "2", label: <a href="/downloads/Forms">Forms</a> },
    { key: "3", label: <a href="/downloads/Factsheet">Factsheet</a> },
    {
      key: "4",
      label: <a href="/downloads/product-literature">Product Literature</a>,
    },
    {
      key: "5",
      label: (
        <a href="/downloads/Scheme-related-documents">
          Scheme Related Documents
        </a>
      ),
    },
    {
      key: "6",
      label: <a href="/downloads/Notice-and-Addendums">Notice & Addendums</a>,
    },
    {
      key: "7",
      label: (
        <a href="/downloads/Portfolio-Disclosure">Portfolio Disclosure</a>
      ),
    },
    {
      key: "8",
      label: (
        <a href="/downloads/Statutory-Disclosure">Statutory Disclosure</a>
      ),
    },
    {
      key: "9",
      label: <a href="/downloads/Scheme-Financials">Scheme Financials</a>,
    },
    {
      key: "10",
      label: <a href="/downloads/Other-disclosure">Other Disclosures</a>,
    },
    {
      key: "11",
      label: (
        <a href="/downloads/Investor-Awareness-Program">
          Investor Awareness Program
        </a>
      ),
    },
  ],
};

  const reachUsMenu = {
    items: [
      { key: "1", label: <a href="/Reach-Us/OurBranches">Our Branches</a> },
      { key: "2", label: <a href="/Reach-Us/KFinBranches">KFIN Branches</a> },
      {
        key: "3",
        label: <a href="/Reach-Us/CompanyDetails">Company Details</a>,
      },
    ],
  };

  const aboutUsMenu = {
    items: [
      {
        key: "1",
        label: <a href="/AboutUs/What-We-Stand-For">What We Stand For</a>,
      },
      { key: "2", label: <a href="/AboutUs/JM-Financial">JM Financial</a> },
      { key: "3", label: <a href="/AboutUs/AMC">AMC</a> },
      {
        key: "4",
        label: (
          <a href="/AboutUs/Corporate-Presentation">Corporate Presentation</a>
        ),
      },
      { key: "5", label: <a href="/AboutUs/Teams">Teams</a> },
      { key: "6", label: <a href="/AboutUs/Trustee-Board">Trustee Board</a> },
      { key: "7", label: <a href="/AboutUs/AMC-Board">AMC Board</a> },
    ],
  };


  const handleKeyDown = (e, setOpen) => {
    // Open dropdown on Enter or Space without navigating
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault(); // Prevent link navigation
      setOpen((prev) => !prev);
    }
  };


  function useDropdownKeyboard(setOpen, isOpen) {
  const triggerRef = useRef(null);
  const menuRef    = useRef(null);

  const focusFirst = useCallback(() => {
    setTimeout(() => {
      menuRef.current?.querySelector('[role="menuitem"]')?.focus();
    }, 50); // wait for Ant Design to render the menu
  }, []);

  const onKeyDown = useCallback((e) => {
    switch (e.key) {
      case 'Enter':
      case ' ':
        e.preventDefault();
        setOpen(prev => {
          if (!prev) focusFirst();
          return !prev;
        });
        break;
      case 'ArrowDown':
        e.preventDefault();
        setOpen(true);
        focusFirst();
        break;
      case 'ArrowUp':
        e.preventDefault();
        setOpen(true);
        // focus last item instead
        setTimeout(() => {
          const items = menuRef.current?.querySelectorAll('[role="menuitem"]');
          items?.[items.length - 1]?.focus();
        }, 50);
        break;
      case 'Escape':
        e.preventDefault();
        setOpen(false);
        triggerRef.current?.focus();
        break;
      case 'Tab':
        setOpen(false); // close on tab-out, let native tab move focus
        break;
      default:
        break;
    }
  }, [setOpen, isOpen, focusFirst]);

  return { triggerRef, menuRef, onKeyDown };
}


  const handleLoginMenuKeyDown = (e) => {
  const items = loginMenuItemsRef.current;
  const currentIndex = items.indexOf(document.activeElement);

  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();
      const nextIndex = (currentIndex + 1) % items.length;
      items[nextIndex]?.focus();
      break;

    case "ArrowUp":
      e.preventDefault();
      const prevIndex =
        (currentIndex - 1 + items.length) % items.length;
      items[prevIndex]?.focus();
      break;

    case "Escape":
      setOpenLogin(false);
      break;

    case "Tab":
      setOpenLogin(false); // allow normal tab flow
      break;

    default:
      break;
  }
};

  return (
    <>
      {/* <HamburgerMenu /> */}
  <header className="main-header" style={{position: "sticky"}}>

      <section className="header-sc">
        <Container>
          <Row>
            {/* <p className="exting-web">
              Please{" "}
              <a href="/Confirmation" target="_blank">
                click here
              </a>{" "}
              in case you want to access our previous website.
            </p> */}
            {/* <p className="exting-web">Your browsing experience matters to us. If you're facing difficulties with files or links, <a href="https://www.prev.jmfinancialmf.com/" target="blank">click here</a> to visit our old website</p> */}

            <p className="exting-web">
              {/* Left side */}

              {/* <LanguageToggle/> */}

              {/* <span className="language-toggle">
              <span onClick={() => handleLanguageChange("en")} style={{cursor: "pointer"}}>English</span> | 
              <span onClick={() => handleLanguageChange("hi")} style={{cursor: "pointer"}}>हिन्दी</span>
            </span> */}
            
                    <a
                      href="#main-content"
                      className="skip-link"   // Add this for styling (hide it until focused)
                      onClick={(e) => {
                        e.preventDefault();

                        const mainContent = document.getElementById("main-content");
                        
                        if (mainContent) {
                          // Scroll to main content smoothly
                          mainContent.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                          });

                          // Focus it for keyboard/screen reader users
                          setTimeout(() => {
                            mainContent.focus();
                          }, 600); // Small delay so scroll finishes first
                        }
                      }}
                    >
                      Skip to main content
                    </a>
                {/* Right side controls */}
                <span className="accessibility-controls" style={{cursor: "pointer"}} role="region" aria-label="Text size and accessibility options">
                  {/* <span
                  style={{marginRight: "1rem"}}
                    onClick={() =>
                      document.documentElement.setAttribute(
                        "data-theme",
                        document.documentElement.getAttribute("data-theme") === "high-contrast"
                          ? "default"
                          : "high-contrast"
                      )
                    }
                  >
                    High Contrast
                  </span> */}
                {/* <span>
                    <DarkModeTheme/>
                  </span> */}
                  <span>
                   {/* {" | "} */}
                   <FontSizeController/>
                   
                  {/* <span onClick={() => changeFontSize(-2)}>A-</span> */}
                  {/* <span onClick={() => resetFontSize()}>A</span>
                   {" | "}
                  <span onClick={() => changeFontSize(2)}>A+</span>
                   {" | "} */}
                </span>
              </span>
            </p>
            <Col sm={12}>
              <HamburgerMenu />
              <div className="logo-img">
                <a href="/">
                  <img
                    src={logo}
                    alt="JM_MutualFund Logo"
                    className="img-fluid"
                  />
                </a>
              </div>

              <div className="menu-pnl">
  <div className="menu-desk">
    <ul id="HeaderDiv">

      {/* ── Investor ─────────────────────────────────────────── */}
      <li className={splitLocation[1] === "" ? "active" : ""}>
        <Dropdown
          menu={investorMenu}
          trigger={["hover", "click"]}
          onOpenChange={setOpenInvestor}
          open={openInvestor}
          popupRender={investor.popupRender}
        >
          <a
            ref={investor.triggerRef}
            href="/"
            className="HeadA"
            role="button"
            aria-haspopup="true"
            aria-expanded={openInvestor}
            tabIndex={0}
            onKeyDown={investor.onKeyDown}
             onClick={(e) => {
            if (e.detail === 0) e.preventDefault();
          }}
          >
            <Space size={3}>
              Investor
              {openInvestor
                ? <UpOutlined   style={{ fontSize: "9px" }} />
                : <DownOutlined style={{ fontSize: "9px" }} />}
            </Space>
          </a>
        </Dropdown>
      </li>

      {/* ── Partner ──────────────────────────────────────────── */}
      <li className={splitLocation[1] === "PartnersCorner" ? "active" : ""}>
        <Dropdown
          menu={partnerCornerMenu}
          trigger={["hover", "click"]}
          onOpenChange={setOpenPartner}
          open={openPartner}
          popupRender={partner.popupRender}
        >
          <a
            ref={partner.triggerRef}
            href="/PartnersCorner"
            className="HeadA"
            role="button"
            aria-haspopup="true"
            aria-expanded={openPartner}
            tabIndex={0}
            onKeyDown={partner.onKeyDown}
             onClick={(e) => {
            if (e.detail === 0) e.preventDefault();
          }}
          >
            <Space size={3}>
              Partner
              {openPartner
                ? <UpOutlined   style={{ fontSize: "9px" }} />
                : <DownOutlined style={{ fontSize: "9px" }} />}
            </Space>
          </a>
        </Dropdown>
      </li>

      {/* ── Products ─────────────────────────────────────────── */}
      <li className={splitLocation[1] === "products" ? "active" : ""}>
        <Dropdown
          menu={productMenu}
          trigger={["hover", "click"]}
          onOpenChange={setOpenProducts}
          open={openProducts}
          popupRender={products.popupRender}
        >
          <a
            ref={products.triggerRef}
            href="/products"
            className="HeadA"
            role="button"
            aria-haspopup="true"
            aria-expanded={openProducts}
            tabIndex={0}
            onKeyDown={products.onKeyDown}
            onClick={(e) => {
            if (e.detail === 0) e.preventDefault();
          }}
          >
            <Space size={3}>
              Products
              {openProducts
                ? <UpOutlined   style={{ fontSize: "9px" }} />
                : <DownOutlined style={{ fontSize: "9px" }} />}
            </Space>
          </a>
        </Dropdown>
      </li>

      {/* ── Insights ─────────────────────────────────────────── */}
      <li className={splitLocation[1] === "Insights" ? "active" : ""}>
        <Dropdown
          menu={insightsMenu}
          trigger={["hover", "click"]}
          onOpenChange={setOpenInsights}
          open={openInsights}
          popupRender={insights.popupRender}
        >
          <a
            ref={insights.triggerRef}
            href="/Insights"
            className="HeadA"
            role="button"
            aria-haspopup="true"
            aria-expanded={openInsights}
            tabIndex={0}
            onKeyDown={insights.onKeyDown}
            onClick={(e) => {
            if (e.detail === 0) e.preventDefault();
          }}
          >
            <Space size={3}>
              Insights
              {openInsights
                ? <UpOutlined   style={{ fontSize: 9 }} />
                : <DownOutlined style={{ fontSize: 9 }} />}
            </Space>
          </a>
        </Dropdown>
      </li>

      {/* ── Downloads ────────────────────────────────────────── */}
      <li className={splitLocation[1] === "downloads" ? "active" : ""}>
        <Dropdown
          menu={downloadsMenu}
          trigger={["hover", "click"]}
          onOpenChange={setOpenDownloads}
          open={openDownloads}
          popupRender={downloads.popupRender}
        >
          <a
            ref={downloads.triggerRef}
            href="/downloads/Factsheet"
            className="HeadA cursorpointer"
            role="button"
            aria-haspopup="true"
            aria-expanded={openDownloads}
            tabIndex={0}
            onKeyDown={downloads.onKeyDown}
              onClick={(e) => {
            if (e.detail === 0) e.preventDefault();
          }}
          >
            <Space size={3}>
              Downloads
              {openDownloads
                ? <UpOutlined   style={{ fontSize: 9 }} />
                : <DownOutlined style={{ fontSize: 9 }} />}
            </Space>
          </a>
        </Dropdown>
      </li>

      {/* ── Reach Us ─────────────────────────────────────────── */}
      <li className={splitLocation[1] === "Reach-Us" ? "active" : ""}>
        <Dropdown
          menu={reachUsMenu}
          trigger={["hover", "click"]}
          onOpenChange={setOpenReachUs}
          open={openReachUs}
          popupRender={reachUs.popupRender}
        >
          <a
            ref={reachUs.triggerRef}
            href="/Reach-Us"
            className="HeadA"
            role="button"
            aria-haspopup="true"
            aria-expanded={openReachUs}
            tabIndex={0}
            onKeyDown={reachUs.onKeyDown}
             onClick={(e) => {
            if (e.detail === 0) e.preventDefault();
          }}
          >
            <Space size={3}>
              Reach Us
              {openReachUs
                ? <UpOutlined   style={{ fontSize: 9 }} />
                : <DownOutlined style={{ fontSize: 9 }} />}
            </Space>
          </a>
        </Dropdown>
      </li>

      {/* ── About Us ─────────────────────────────────────────── */}
      <li className={splitLocation[1] === "AboutUs" ? "active" : ""}>
        <Dropdown
          menu={aboutUsMenu}
          trigger={["hover", "click"]}
          onOpenChange={setOpenAbout}
          open={openAbout}
          popupRender={about.popupRender}
        >
          <a
            ref={about.triggerRef}
            href="/AboutUs"
            className="HeadA"
            role="button"
            aria-haspopup="true"
            aria-expanded={openAbout}
            tabIndex={0}
            onKeyDown={about.onKeyDown}
             onClick={(e) => {
            if (e.detail === 0) e.preventDefault();
          }}
          >
            <Space size={3}>
              About Us
              {openAbout
                ? <UpOutlined   style={{ fontSize: "9px" }} />
                : <DownOutlined style={{ fontSize: "9px" }} />}
            </Space>
          </a>
        </Dropdown>
      </li>

      {/* ── KYC Status (no dropdown, no hook needed) ─────────── */}
      <li className={splitLocation[1] === "KycUpdate" ? "active" : ""}>
        <a href="/KycUpdate" className="HeadA" tabIndex={0} ref={kycRef}>
          KYC Status
        </a>
      </li>

    </ul>
  </div>

  {/* ── Mobile slider (unchanged) ──────────────────────────────── */}
  <div className="menu-mobile">
    <Slider {...settings}>
      <div>
        <p className={splitLocation[1] === "" ? "active" : ""}>
          <a href="" className="HeadA">Investor</a>
        </p>
      </div>
      <div>
        <p className={splitLocation[1] === "PartnersCorner" ? "active" : ""}>
          <a href="/PartnersCorner" className="HeadA">Partner</a>
        </p>
      </div>
      <div>
        <p className={splitLocation[1] === "products" ? "active" : ""}>
          <a href="/products" className="HeadA">Products</a>
        </p>
      </div>
      <div>
        <p className={splitLocation[1] === "Insights" ? "active" : ""}>
          <a href="/Insights/Video-Gallery" className="HeadA">Insights</a>
        </p>
      </div>
      <div>
        <p className={splitLocation[1] === "downloads" ? "active" : ""}>
          <a className="cursorpointer HeadA" href="/downloads/Factsheet">Downloads</a>
        </p>
      </div>
      <div>
        <p className={splitLocation[1] === "Reach-Us" ? "active" : ""}>
          <a href="/Reach-Us" className="HeadA">Reach Us</a>
        </p>
      </div>
      <div>
        <p className={splitLocation[1] === "AboutUs" ? "active" : ""}>
          <a href="/AboutUs" className="HeadA">About Us</a>
        </p>
      </div>
      <div>
        <p className={splitLocation[1] === "KycUpdate" ? "active" : ""}>
          <a href="/KycUpdate" className="HeadA blink_me">KYC Status</a>
        </p>
      </div>
    </Slider>
  </div>
</div>

             <div className="login-ham-btn dropdown">
              <ul>
               
                <li>
                  <button
                    // onClick={myFunction}
                    onClick={toggleDropdown}
                    className="login-btn dropbtn"
                    // aria-label="login dropdown button"
                    aria-expanded= {openLogin}
                    aria-controls="myDropdown"
                    onKeyDown={(e) => {
                    if (e.key === "Escape") {
                      setOpenLogin(false);
                    }
                  }}
                  >
                    {" "}
                    Login
                  </button>
                </li>

                
                <li>
                  <div
                    id="myDropdown"
                    className="dropdown-content login-popup-link"
                  >
                    <ul className="link-div-popup">
                      <li>
                        <img src={invester} alt="Investor" />
                        <a
                          href="https://investor.jmfinancialmf.com/jmfinvestor/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Investor
                        </a>
                      </li>
                      <li>
                        <img src={partnerImage} alt="Partner" />
                        <a
                          href=" https://dit.jmfinancialmf.com"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Partner
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>

                
                <li onClick={clickHanlder}>
                  <img
                    src={hamburger}
                    alt="Menu"
                    className="img-fluid"
                  />
                </li>
              </ul>
            </div>
              {show && (
                <div id="aboutus" className="who-we-are-popup">
                  <div className="text-div">
                    <h2>About Us</h2>
                    <p>
                      JM Financial Will Be The Most Trusted Partners For Every
                      Stakholder In Financial World.
                    </p>
                  </div>
                  <div className="link-div">
                    <ul>
                      <li>
                        <a href="//OurCororpate">
                          <img src={coporate} alt="coporate" />
                          Teams
                        </a>
                      </li>
                      <li>
                        <a href="/AboutUs/TheAMC">
                          <img src={AMC} alt="AMC" />
                          AMC Board
                        </a>
                      </li>
                      <li>
                        <a href="/AboutUs/Sponsor">
                          <img src={Sponsor} alt="Sponsor" />
                          Sponsor
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </Col>
            <div className="search-bar-wrapper" id="search-bar-wrapper">
              <div className="container">
                {/* <div className="search-bar-container">
                  <input
                    type="text"
                    name=""
                    id="search_fund"
                    placeholder="Search for products and services..."
                    onClick={OpenSearch}
                    onChange={handleInputChange}
                  />
                  <div className="icon-container">
                    <i className="fa fa-search" aria-hidden="true"></i>
                  </div>
                </div> */}
              </div>
            </div>

            <div id="popup-box1" className="popup-position">
              <div className="search-popup-container">
                {!showPop && (
                  <div className="left">
                    <div className="invest">
                      <p className="head">Popular Search</p>
                      <div className="invest-fund">
                        {dataCompt &&
                          dataCompt?.map(({ SectionName, LinkPath }) => (
                            <>
                              <div className="funds">
                                <a href={LinkPath != null ? LinkPath : ""}>
                                  {SectionName}
                                </a>
                              </div>
                            </>
                          ))}
                      </div>
                    </div>
                    <div className="looking-section">
                      <div className="invest">
                        <p className="head">I want to Invest in</p>
                        <div className="invest-fund">
                          <div className="funds">
                            <a
                              href={
                                "products/Equity/JM-Flexicap-Fund/J358/Regular-Plan-Growth-Option"
                              }
                            >
                              JM Flexi Cap Fund
                            </a>
                          </div>
                          <div className="funds">
                            {/* <a
                              href={
                                "/products/Equity/JM-ELSS-Tax-Saver-Fund-(Formerly-known-as-JM-Tax-Gain-Fund)/J282/Regular-Plan-Growth-Option"
                              }
                            > */}
                            <a
                              href={
                                "/products/Equity/JM-ELSS-Tax-Saver-Fund/J282/Regular-Plan-Growth-Option"
                              }
                            >
                              JM ELSS Tax Saver Fund
                            </a>
                          </div>
                          <div className="funds">
                            <a
                              href={
                                "products/Equity/JM-Midcap-Fund/J644/Regular-Plan-Growth-Option"
                              }
                            >
                              JM Midcap Fund
                            </a>
                          </div>
                          <div className="funds">
                            <a
                              href={
                                "products/Equity/JM-Value-Fund/J246/Regular-Plan-Growth-Option"
                              }
                            >
                              JM Value Fund
                            </a>
                          </div>
                          <div className="funds">
                            <a
                              href={
                                "products/Fixed-Income/JM-Short-Duration-Fund/J638/Regular-Plan-Growth-Option"
                              }
                            >
                              JM Short Duration Fund
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* {showPop && (<div className="left fundNew">
                                    <div className="popupFundSearch">
                                        {(dataSearch.length > 0) ?
                                            dataSearch && dataSearch.map(({ Title, SectionPath, Description }) => (
                                                <div className="popupFund">
                                                    <h2>{Title}</h2>
                                                    <div className="fundDiv">
                                                        <p>{Description}</p>
                                                        <a href={SectionPath}>Know More</a>
                                                    </div>
                                                    <hr></hr>
                                                </div>
                                            )) : <h6 className="errorSearch">No Data Found !!!</h6>}
                                    </div>
                                </div>)} */}
                {showPop && (
                  <div className="left fundNew">
                    <div className="popupFundSearch">
                      {dataSearch && dataSearch.length > 0 ? (
                        dataSearch.map(
                          ({ Title, SectionPath, Description }) => (
                            <div className="popupFund" key={SectionPath}>
                              <h2>{Title}</h2>
                              <div className="fundDiv">
                                <p>{Description}</p>
                                <a href={SectionPath}>Know More</a>
                              </div>
                              <hr />
                            </div>
                          ),
                        )
                      ) : (
                        <h6 className="errorSearch">No Data Found !!!</h6>
                      )}
                    </div>
                  </div>
                )}
                <div className="right">
                  <div className="head">
                    <p>What are you looking for?</p>
                  </div>
                  <ul className="partners-container">
                    <li>
                      <span className="img-container">
                        <img src={popup_about1} alt="FactSheets" />
                      </span>
                      <p>
                        <a href="/downloads/Factsheet">Factsheet</a>
                      </p>
                    </li>
                    <li>
                      <span className="img-container">
                        <img src={popup_about2} alt="NAVs-and-IDCW" />
                      </span>
                      <p>
                        <a href="/NAVs-and-IDCW/">NAV’s & IDCW</a>
                      </p>
                    </li>
                    <li>
                      <span className="img-container">
                        <img src={popup_about3} alt="products" />
                      </span>
                      <p>
                        <a href="/products">Products</a>
                      </p>
                    </li>
                    {/* <li>
                                            <span className="img-container">
                                                <img src={popup_about4} alt="Plan-Wise-Investment" />
                                            </span>
                                            <p><a href='Calculator/Plan-Wise-Investment'>Calculator</a></p>
                                        </li> */}
                    <li>
                      <span className="img-container">
                        <img src={popup_about5} alt="PressRelease" />
                      </span>
                      <p>
                        <a href="Communication-Hub/media-interaction">
                          Communication Hub
                        </a>
                      </p>
                    </li>
                    <div className="portal-box">
                      <p>
                        <a
                          href="https://investor.jmfinancialmf.com/jmfinvestor/"
                          target="blank"
                        >
                          Investor Portal
                        </a>
                      </p>
                      <p>
                        <a
                          href="https://dit.jmfinancialmf.com/portal/login"
                          target="blank"
                        >
                          Partner Portal
                        </a>
                      </p>
                    </div>
                  </ul>
                </div>
                <div className="top-bar-btns">
                  <ul className="social-icons">
                    <li>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/@JMFinancialAMC/"
                      >
                        <img src={popup_social1} alt="popup_social1" />
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.linkedin.com/company/jm-financial-mutual-fund-ltd/mycompany/"
                      >
                        <img src={popup_social2} alt="popup_social2" />
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/jmfinancialmutualfund/"
                      >
                        <img src={popup_social3} alt="popup_social3" />
                      </a>
                    </li>
                  </ul>
                  <button className="close-btn" aria-label="close button">
                    <img src={Close} alt="Close" onClick={closepopup} />
                  </button>
                </div>
              </div>
            </div>
            {logoutpopup ? (
              <div className="user_profile">
                <div id="overlay" onClick={closeNav}>
                  {" "}
                </div>
                <Container>
                  <Row>
                    <Col xs={12}>
                      <div className="user_profile">
                        <div className="userprofile_dropdown">
                          <div className="userprofile_bio media">
                            <div className="usernameimg_panel media">
                              <span className="user_fname">
                                {username != null
                                  ? username.substring(0, 1)
                                  : ""}
                              </span>
                            </div>
                            <div className="user_nameemail media-body">
                              <span className="userbio_name">{username}</span>
                            </div>
                          </div>

                          <div className="userprofile_biogrid">
                            <ul className="userprofile_biolist">
                              <li>
                                <span className="userprfl_bioicon">
                                  <img
                                    src={imglogout}
                                    className="orderreport"
                                  />
                                </span>
                                <span
                                  className="userprfl_biotext"
                                  onClick={logout}
                                >
                                  Logout
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            ) : null}
          </Row>
        </Container>
      </section>
  </header>
      {/* {showLoginPopup && <InvesterDistributerLogin handleClosePopuplogin={handleClosePopuplogin} />} */}
      {/* <InvesterDistributerLogin showpopup={showLoginPopup} handleClosePopuplogin={handleClosePopuplogin} /> */}
    </>
  );
}

export default Header;
